export interface StageOption {
  label: string;
  value: 'inquiriesToApps' | 'applicationsToAdmits' | 'admitsToEnrollment';
}

export const STAGES_OPTIONS: StageOption[] = [
  { label: 'Inquiries to Apps', value: 'inquiriesToApps' },
  { label: 'Applications to Admits', value: 'applicationsToAdmits' },
  { label: 'Admits to Enrollment', value: 'admitsToEnrollment' },
];

export const DATE_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{2}$/;

export const SELECT_STYLES = {
  padding: 0,
  height: '2',
};

export interface YearOption {
  label: string;
  value: number;
}

export interface CohortOption {
  label: string;
  value: string;
}

export interface MonitoringFormValues {
  cohort: CohortOption | null;
  comparisonYear1: YearOption | null;
  comparisonYear2: YearOption | null;
  inquiriesToApps: string;
  applicationsToAdmits: string;
  admitsToEnrollment: string;
}

export const FORM_DEFAULT_VALUES: MonitoringFormValues = {
  cohort: null,
  comparisonYear1: null,
  comparisonYear2: null,
  inquiriesToApps: '',
  applicationsToAdmits: '',
  admitsToEnrollment: '',
};
